// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */

/* Reset default margins and paddings */
body, html {
    margin: 0;
    padding: 0;
    font-family: 'Arial', sans-serif;
}

a {
    color: black;
}
a:visited {
    color: black;
}

/* Main container styles */
.app-container {
    display: flex;
    height: 100vh;
}

/* Sidebar styles */
.sidebar {
    position: fixed;
    width: 120px;
    background-image: linear-gradient(to right, #ffffff, #dfdfdf);
    padding: 20px;
    overflow-y: none;
    top: 0;
    bottom: 0;
}

.sidebar ul {
    list-style-type: none;
    padding: 0;
    color: #000000;
}

.sidebar ul li {
    margin-bottom: 10px;
    cursor: pointer;
}

.sidebar ul li:hover {
    background-color: #c0c0c0;
}

/* Content styles */
.content {
    flex: 1 1;
    padding: 20px;
    margin-left: 160px;
}

.content h2 {
    margin-bottom: 20px;
}

.announcer {
    text-align: center;
}

.announcer button {
    margin: 5px;
    width: 18%;
    height: 60px;
    font-size: 26pt;    
}

.announcer .bibheader {
    font-size: 48pt;
    margin-bottom: 15px;
}

.announcer td {
    font-size: 30pt;
}

.dashboard {
    max-width: 1100px;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
}

.dashboard-subtitle {
    color: #4b4b4b;
    font-size: 0.95rem;
}

.dashboard-metrics {
    display: flex;
    gap: 12px;
}

.metric {
    background: #f3f3f3;
    border-radius: 12px;
    padding: 10px 14px;
    min-width: 90px;
    text-align: center;
}

.metric-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b6b6b;
}

.metric-value {
    font-size: 1.4rem;
    font-weight: bold;
}

.dashboard-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

.dashboard-search {
    flex: 1 1;
    min-width: 220px;
    padding: 8px 12px;
    border-radius: 10px;
    border: 1px solid #cfcfcf;
}

.dashboard-filters {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.filter-chip {
    border: 1px solid #c9c9c9;
    background: #ffffff;
    border-radius: 999px;
    padding: 6px 12px;
    cursor: pointer;
}

.filter-chip.active {
    background: #222222;
    color: #ffffff;
    border-color: #222222;
}

.dashboard-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
}

.panel {
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e0e0e0;
    padding: 18px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.03);
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.panel-meta {
    font-size: 0.85rem;
    color: #6b6b6b;
}

.issue-list,
.suite-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.issue-card,
.suite-card {
    border-radius: 14px;
    padding: 14px;
    background: #f9f9f9;
    border: 1px solid #e5e5e5;
}

.issue-main {
    margin-bottom: 8px;
}

.issue-title {
    font-weight: 600;
    margin-bottom: 4px;
}

.issue-summary {
    color: #555555;
    font-size: 0.9rem;
}

.raw-times-page {
    max-width: 1400px;
}

.raw-times-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 12px;
}

.raw-times-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.raw-times-filter {
    width: 90px;
    height: 34px;
    border: 1px solid #cfcfcf;
    border-radius: 6px;
    padding: 0 10px;
}

.raw-times-status {
    margin-bottom: 12px;
    color: #444444;
}

.raw-times-grid {
    display: grid;
    grid-template-columns: minmax(420px, 1fr) minmax(520px, 1.15fr);
    gap: 16px;
}

.raw-times-panel {
    border: 1px solid #dddddd;
    border-radius: 8px;
    padding: 12px;
    background: #ffffff;
}

.raw-times-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.raw-times-panel-header h3 {
    margin: 0;
}

.raw-times-panel-header span {
    color: #666666;
    font-size: 0.85rem;
}

.raw-times-scroll {
    height: calc(100vh - 210px);
    overflow-y: auto;
}

.raw-times-scroll td {
    padding: 4px 8px;
    white-space: nowrap;
}

@media (max-width: 1100px) {
    .raw-times-header,
    .raw-times-actions {
        align-items: stretch;
        flex-direction: column;
    }

    .raw-times-grid {
        grid-template-columns: 1fr;
    }

    .raw-times-scroll {
        height: 420px;
    }
}

.issue-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 8px;
}

.issue-meta {
    display: flex;
    gap: 14px;
    font-size: 0.8rem;
    color: #666666;
    flex-wrap: wrap;
}

.pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.pill.neutral {
    background: #ececec;
    color: #444444;
}

.severity-high {
    background: #ffe0e0;
    color: #a10000;
}

.severity-medium {
    background: #fff1d6;
    color: #9a5b00;
}

.severity-low {
    background: #e4f2ff;
    color: #004b8d;
}

.status-open {
    background: #ffe7e7;
    color: #b20000;
}

.status-monitoring {
    background: #fff3d1;
    color: #8a5a00;
}

.status-resolved,
.status-pass {
    background: #d8f5e1;
    color: #0f6b2f;
}

.status-warning,
.status-warn {
    background: #fff2cc;
    color: #8a5a00;
}

.status-fail {
    background: #ffd5d5;
    color: #9a0000;
}

.suite-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;
}

.suite-title {
    font-weight: 600;
}

.suite-meta {
    font-size: 0.85rem;
    color: #6b6b6b;
}

.suite-checks {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.check-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
    padding-bottom: 4px;
    border-bottom: 1px dashed #e0e0e0;
}

.check-row:last-child {
    border-bottom: none;
}

.check-status {
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.05em;
}

.check-pass .check-status {
    color: #0f6b2f;
}

.check-warn .check-status,
.check-warning .check-status {
    color: #8a5a00;
}

.check-fail .check-status {
    color: #9a0000;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,uCAAuC;AACvC;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,YAAY;IACZ,6DAA6D;IAC7D,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,+DAA+D;IAC/D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;;QAEI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* src/App.css */\n\n/* Reset default margins and paddings */\nbody, html {\n    margin: 0;\n    padding: 0;\n    font-family: 'Arial', sans-serif;\n}\n\na {\n    color: black;\n}\na:visited {\n    color: black;\n}\n\n/* Main container styles */\n.app-container {\n    display: flex;\n    height: 100vh;\n}\n\n/* Sidebar styles */\n.sidebar {\n    position: fixed;\n    width: 120px;\n    background-image: linear-gradient(to right, #ffffff, #dfdfdf);\n    padding: 20px;\n    overflow-y: none;\n    top: 0;\n    bottom: 0;\n}\n\n.sidebar ul {\n    list-style-type: none;\n    padding: 0;\n    color: #000000;\n}\n\n.sidebar ul li {\n    margin-bottom: 10px;\n    cursor: pointer;\n}\n\n.sidebar ul li:hover {\n    background-color: #c0c0c0;\n}\n\n/* Content styles */\n.content {\n    flex: 1;\n    padding: 20px;\n    margin-left: 160px;\n}\n\n.content h2 {\n    margin-bottom: 20px;\n}\n\n.announcer {\n    text-align: center;\n}\n\n.announcer button {\n    margin: 5px;\n    width: 18%;\n    height: 60px;\n    font-size: 26pt;    \n}\n\n.announcer .bibheader {\n    font-size: 48pt;\n    margin-bottom: 15px;\n}\n\n.announcer td {\n    font-size: 30pt;\n}\n\n.dashboard {\n    max-width: 1100px;\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.dashboard-subtitle {\n    color: #4b4b4b;\n    font-size: 0.95rem;\n}\n\n.dashboard-metrics {\n    display: flex;\n    gap: 12px;\n}\n\n.metric {\n    background: #f3f3f3;\n    border-radius: 12px;\n    padding: 10px 14px;\n    min-width: 90px;\n    text-align: center;\n}\n\n.metric-label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #6b6b6b;\n}\n\n.metric-value {\n    font-size: 1.4rem;\n    font-weight: bold;\n}\n\n.dashboard-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.dashboard-search {\n    flex: 1;\n    min-width: 220px;\n    padding: 8px 12px;\n    border-radius: 10px;\n    border: 1px solid #cfcfcf;\n}\n\n.dashboard-filters {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.filter-chip {\n    border: 1px solid #c9c9c9;\n    background: #ffffff;\n    border-radius: 999px;\n    padding: 6px 12px;\n    cursor: pointer;\n}\n\n.filter-chip.active {\n    background: #222222;\n    color: #ffffff;\n    border-color: #222222;\n}\n\n.dashboard-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 20px;\n}\n\n.panel {\n    background: #ffffff;\n    border-radius: 16px;\n    border: 1px solid #e0e0e0;\n    padding: 18px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.03);\n}\n\n.panel-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.panel-meta {\n    font-size: 0.85rem;\n    color: #6b6b6b;\n}\n\n.issue-list,\n.suite-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.issue-card,\n.suite-card {\n    border-radius: 14px;\n    padding: 14px;\n    background: #f9f9f9;\n    border: 1px solid #e5e5e5;\n}\n\n.issue-main {\n    margin-bottom: 8px;\n}\n\n.issue-title {\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.issue-summary {\n    color: #555555;\n    font-size: 0.9rem;\n}\n\n.raw-times-page {\n    max-width: 1400px;\n}\n\n.raw-times-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 12px;\n}\n\n.raw-times-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.raw-times-filter {\n    width: 90px;\n    height: 34px;\n    border: 1px solid #cfcfcf;\n    border-radius: 6px;\n    padding: 0 10px;\n}\n\n.raw-times-status {\n    margin-bottom: 12px;\n    color: #444444;\n}\n\n.raw-times-grid {\n    display: grid;\n    grid-template-columns: minmax(420px, 1fr) minmax(520px, 1.15fr);\n    gap: 16px;\n}\n\n.raw-times-panel {\n    border: 1px solid #dddddd;\n    border-radius: 8px;\n    padding: 12px;\n    background: #ffffff;\n}\n\n.raw-times-panel-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.raw-times-panel-header h3 {\n    margin: 0;\n}\n\n.raw-times-panel-header span {\n    color: #666666;\n    font-size: 0.85rem;\n}\n\n.raw-times-scroll {\n    height: calc(100vh - 210px);\n    overflow-y: auto;\n}\n\n.raw-times-scroll td {\n    padding: 4px 8px;\n    white-space: nowrap;\n}\n\n@media (max-width: 1100px) {\n    .raw-times-header,\n    .raw-times-actions {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .raw-times-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .raw-times-scroll {\n        height: 420px;\n    }\n}\n\n.issue-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n\n.issue-meta {\n    display: flex;\n    gap: 14px;\n    font-size: 0.8rem;\n    color: #666666;\n    flex-wrap: wrap;\n}\n\n.pill {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.pill.neutral {\n    background: #ececec;\n    color: #444444;\n}\n\n.severity-high {\n    background: #ffe0e0;\n    color: #a10000;\n}\n\n.severity-medium {\n    background: #fff1d6;\n    color: #9a5b00;\n}\n\n.severity-low {\n    background: #e4f2ff;\n    color: #004b8d;\n}\n\n.status-open {\n    background: #ffe7e7;\n    color: #b20000;\n}\n\n.status-monitoring {\n    background: #fff3d1;\n    color: #8a5a00;\n}\n\n.status-resolved,\n.status-pass {\n    background: #d8f5e1;\n    color: #0f6b2f;\n}\n\n.status-warning,\n.status-warn {\n    background: #fff2cc;\n    color: #8a5a00;\n}\n\n.status-fail {\n    background: #ffd5d5;\n    color: #9a0000;\n}\n\n.suite-header {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.suite-title {\n    font-weight: 600;\n}\n\n.suite-meta {\n    font-size: 0.85rem;\n    color: #6b6b6b;\n}\n\n.suite-checks {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.check-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 0.9rem;\n    padding-bottom: 4px;\n    border-bottom: 1px dashed #e0e0e0;\n}\n\n.check-row:last-child {\n    border-bottom: none;\n}\n\n.check-status {\n    text-transform: uppercase;\n    font-size: 0.7rem;\n    letter-spacing: 0.05em;\n}\n\n.check-pass .check-status {\n    color: #0f6b2f;\n}\n\n.check-warn .check-status,\n.check-warning .check-status {\n    color: #8a5a00;\n}\n\n.check-fail .check-status {\n    color: #9a0000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
